import httpClient from '../../client'

import apiRoutes from '../constants'

const getCompanies = async ({page, limit, format, ...rest}) => {
  try {
    const url = format ? `${apiRoutes.GET_COMPANIES}.${format}` : apiRoutes.GET_COMPANIES
    const {data} = await httpClient.get(url, {params: {limit, page, ...rest}})

    if (data) {
      return data
    }

    throw data
  } catch (error) {
    console.log(`Error calling companies with ${JSON.stringify({limit, page})}`, error)

    return error
  }
}

export default getCompanies
